import { EventEmitter, ViewChildren } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
@Component({
  selector: 'app-empfilter',
  templateUrl: './empfilter.component.html',
  styleUrls: ['./empfilter.component.css']
})
export class EmpfilterComponent implements OnInit , AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  designationColl: any = [];
  payrollgrpColl: any = [];
  branchColl: any = [];
  departmentColl: any = [];
  locationColl: any = [];
  nationalityColl: any = [];
 
  @Input() formname: string = "";

  @Input() designationid: any = null;
  @Input() payrollgrpid: any = null;
  @Input() branchid: any = null;
  @Input() departmentid: any = null;
  @Input() locationid: any = null;
  @Input() nationalityid: any = null;
  @Input() fromdate: any = null;
  @Input() todate: any = null;

  @Output() emitData = new EventEmitter();

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, public loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {
 this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }




  ngOnInit() {
    try {
     
      this.fngetDesignation();
      this.fngetPayrollgrp();
      this.fngetDepartment();
      this.fngetBranch();
      this.fngetLocation();
      this.fngetNationality();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
    ////this.firstipcontrol.first.nativeElement.focus();
  }


  
  fngetDesignation() {
    var data = {
      'designationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.designationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetPayrollgrp() {
    var data = {
      'payrollgrpid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayrollgrp(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollgrpColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetDepartment() {
    var data = {
      'departmentid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.departmentColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetLocation() {
    var data = {
      'locationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLocation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.locationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetNationality() {
    var data = {
      'nationalityid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getNationality(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.nationalityColl = res.json().result;
            console.log(this.nationalityColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnApplyFilter() {
    try {
      var data = {
        status: 'DONE',
        designationid: this.designationid,
        designationname: this.fnGetDesignationname(),
        payrollgrpid: this.payrollgrpid,
        payrollgrpname: this.fnGetPayrollgrpname(),
        branchid: this.branchid,
        branchname: this.fnGetBranchname(),
        departmentid: this.departmentid,
        departmentname: this.fnGetDepartmentname(),
        locationid: this.locationid,
        locationname: this.fnGetLocationname(),
        nationalityid: this.nationalityid,
        nationality: this.fnGetNationalityname(),
        fromdate: this.fromdate,
        todate:this.todate
      
      }
      this.emitData.emit(data);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetDesignationname() {
    var designationname = "";
    for (let abo of this.designationColl) {
      if (this.designationid === abo.designationid) {
        designationname = abo.designationname;
      }
    }

    return designationname
  }
  fnGetPayrollgrpname() {
    var payrollgrpname = "";
    for (let abo of this.payrollgrpColl) {
      if (this.payrollgrpid === abo.payrollgrpid) {
        payrollgrpname = abo.payrollgrpname;
      }
    }

    return payrollgrpname
  }
  fnGetBranchname() {
    var branchname = "";
    for (let abo of this.branchColl) {
      if (this.branchid === abo.branchid) {
        branchname = abo.branchname;
      }
    }

    return branchname
  }
  fnGetDepartmentname() {
    var departmentname = "";
    for (let abo of this.departmentColl) {
      if (this.departmentid === abo.departmentid) {
        departmentname = abo.departmentname;
      }
    }

    return departmentname
  }
  fnGetLocationname() {
    var locationname = "";
    for (let abo of this.locationColl) {
      if (this.locationid === abo.locationid) {
        locationname = abo.locationname;
      }
    }

    return locationname
  }
  fnGetNationalityname() {
    var nationality = "";
    for (let abo of this.nationalityColl) {
      if (this.nationalityid === abo.nationalityid) {
        nationality = abo.nationality;
      }
    }

    return nationality
  }
  // fnDesignationSearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.designationname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  // fnPayrollgrpSearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.payrollgrpname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  // fnBranchSearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.branchname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  // fnDepartmentSearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.departmentname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  // fnLocationSearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.locationname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  // fnNationalitySearchFn(term: string, item: any) {  
  //   term = term.toLocaleLowerCase();
  //   return item.nationalityname.toLocaleLowerCase().indexOf(term) > -1 ||
  //     item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  // }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
